import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminDashboard from './AdminDashboard';
import EngineerDashboard from './EngineerDashboard';
import VenueOwnerDashboard from './VenueOwnerDashboard';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  // Render appropriate dashboard based on user role
  if (user?.role === 'admin') {
    // Admins get the full admin dashboard with complete system visibility
    return <AdminDashboard />;
  } else if (user?.role === 'engineer') {
    // Engineers get the engineer dashboard
    return <EngineerDashboard />;
  } else if (user?.role === 'venue_owner') {
    return <VenueOwnerDashboard />;
  }

  // Default dashboard for other roles
  return <VenueOwnerDashboard />;
};

export default Dashboard;